import { PrintMap } from "esdm-map/dist/map/tools/PrintMap";
import { IPrintOptions } from "esdm-map/dist/map/tools/IPrintOptions";
import { DownloadMapPng } from "esdm-map/dist/map/tools/DownloadMapPng";
import { IMapViewStore } from "esdm-map/dist/map/store/IMapViewStore";
import { IVectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IMapContextMenu } from "esdm-map/dist/map/tools/IMapContextMenu";
import { IFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { OgcMapFilter } from "esdm-map/dist/map/filters/OgcMapFilter";
import { VectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { MapViewStore } from "esdm-map/dist/map/store/MapViewStore";
import { MapContextMenu } from "esdm-map/dist/map/tools/MapContextMenu";
import { ToolTipProvider } from "esdm-map/dist/map/tooltip/ToolTipProvider";
import { IVectorLayerGroupConfig } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { GeoJsonFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/GeoJsonFeatureLoader";
import { ILoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { BoundsLoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { IFeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { MapListRecordsInViewport } from "esdm-map/dist/map/MapListRecordsInViewport";
import { ExtentsNavigation } from "esdm-map/dist/map/controls/ExtentsNavigation";
import { LayerGroupFactory } from "esdm-map/dist/layers/groups/LayerGroupFactory";
import { MapFilters } from "esdm-map/dist/map/filters/MapFilters";
import { GridRef } from "esdm-map/dist/map/controls/GridRef";
import { GeoLocation } from "esdm-map/dist/map/geolocation/geolocation";
import { IMappingTextPack } from "esdm-map/dist/resources/MappingTextPack";
import { MousePosition } from "esdm-map/dist/map/controls/MousePosition";
import { OsOpenNames } from "esdm-map/dist/gazetteer/os/OsOpenNames";
import { MapViewSettingsUrlProvider } from "esdm-map/dist/map/store/MapViewSettingsUrlProvider";
import { IMapViewPermaLink } from "esdm-map/dist/map/tools/IMapViewPermaLink";
import { MapViewPermaLink } from "esdm-map/dist/map/tools/MapViewPermaLink";
import { GeoNames } from "esdm-map/dist/gazetteer/geonames";
import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import { IVectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources/interfaces";
import { VectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources";
import { IBaseLayerFactory } from "esdm-map/dist/baselayers/interfaces/IBaseLayerFactory";
import { CustomMapLayerSwitcherOverlays } from "./CustomMapLayerSwitcherOverlays";

import {
    MapOptions,
    IMap,
    MapLayerSwitcher,
    IMapAreaMask,
    ILogger,
    IResourceFactory,
    IMapListRecordItem,
    IMapFactory,    
    MapFactory,
    Logger,
    MapFeatureInfo
} from "esdm-map";

import { HbsmrStyleFactory } from "./HbsmrStyleFactory";
import { HbsmrResourcefactory } from "./HbsmrResourceFactory";
import { KentRecordType, KentRecordSubType } from "./KentRecordTypes";
import { DefaultLayerConfigurationFactory } from "./DefaultLayerConfigurationFactory";
import { KentHerBoundary } from "./KentHerBoundary";
import { DefaultMapOptions } from "./DefaultMapOptions";
import { TextPackLoader, TextPacks } from "./TextPackLoader";
import { HbsmrIdentity, HbsmrUser } from "./HbsmrUser";
import { MapBase } from "./MapBase";
import { MapToolTip, ToolTipOptions } from "esdm-map/dist/map/tooltip";
import { IDragPanControl } from "esdm-map/dist/map/controls/Interfaces/IDragPanControl";
import { DragPanControlCL } from "./DragPanControlCL";
import { IlayerGroupCollectionConfig } from "esdm-map/dist/layers/groups/IlayerGroupCollectionConfig";
import { LayerGroupCollections } from "esdm-map/dist/layers/groups/LayerGroupCollections";
import { KentBaseMapping_27700 } from "./KentBaseMapping_27700";
import { FeatureAddSmallGeomsAsPoint } from "esdm-map/dist/layers/vector/sources/loaders";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import TextStyle from "ol/style/Text";
import { IWmsLayerGroupConfig, IWmsLayerGroupFactory } from "esdm-map/dist/layers/groups/wms/interfaces";
import { WmsLayerGroupFactory } from "esdm-map/dist/layers/groups/wms";
import { Tooltip } from "bootstrap"
import { debounce } from "debounce";
//import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS';
//import WMTSCapabilities from 'ol/format/WMTSCapabilities';

import "../wwwroot/css/Swipe.css"

$(function () {  

    /*const parser = new WMTSCapabilities();

    fetch('https://webapps.kent.gov.uk/server/rest/services/BASEMAPS/OS_Colour/MapServer/WMTS/1.0.0/WMTSCapabilities.xml')
        .then(function (response) {
            return response.text();
        })
        .then(function (text) {
            debugger;
            const result = parser.read(text);
            const options = optionsFromCapabilities(result, {
                layer: 'BASEMAPS_OS_Colour',
                matrixSet: 'default028mm',
            });

            var x = 2;
        });*/

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    })
         
    let printOptions: PrintMap = new PrintMap();

    if (!printOptions.isPrintMap) {        
        resizeMap();
        window.addEventListener('resize', debounce(resizeMap, 250));    
    } 

    function resizeMap() {
        //use max footer height, especially on mobile
        var fHeight = $("footer").height();
        fHeight = Math.min(fHeight, 200);

        var height = $(window).height() - $("#mapContainer").offset().top;
        if (height <= 400) {
            height = 400;
        }
        $('#mapContainer').height(height);
        $("#slide-content").height(height - 55);
    };



    let ele = $("#theMap");
    if (ele.length === 1) {      
        HbsmrIdentity.fetch().then(function (e) {
            //let user = e;
            //if (e) {
            //    console.log(e.userId);
            //} else {
            //    console.log("401 - UnAuthorised");
            //}
            loadMap(e);
        });
    } 

    function loadMap(user: HbsmrUser) {
        let maxFeatureCount: number = <number>ele.data("max-feature-count");
        let init = function (textpacks: TextPacks) {
            let map = new MainMap("theMap", maxFeatureCount, printOptions, textpacks.mapping, user);
        }
        TextPackLoader.load().then(init);
    }

});

export class MainMap extends MapBase {
        
    private mfOptions: MapOptions;
    public map: IMap;
    private mapStore: IMapViewStore;
    private ls: MapLayerSwitcher;
    private infoPopup: MapFeatureInfo;
    private initialised: boolean = false;
    private layerGroups: LayerGroupCollections;
    private styleFactory: IStyleFactory;
    private herMask: IMapAreaMask;
    private geoNames: GeoNames;
    private osOpenNames: OsOpenNames;
    private gridRefFinder: GridRef;
    private logger: ILogger;   
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private wmsLayerGroupFactory: IWmsLayerGroupFactory;
    private layerGroupFactory: LayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;    
    private downloadPng: DownloadMapPng;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;
    private recordList: MapListRecordsInViewport;
    private geoLocation: GeoLocation;
    private extentsNavigation: ExtentsNavigation;
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private mapViewSettingProvider: MapViewSettingsUrlProvider;
    private mapListRecordItem: IMapListRecordItem;
    private mapViewPermaLink: IMapViewPermaLink;
    private mousePosition: MousePosition;
    private mapToolTip: MapToolTip;
    private dragPan: IDragPanControl;

    public constructor(
        public mapElementId: string,       
        public maxFeatureCount: number,
        public printOptions: IPrintOptions,
        mappingTextPack: IMappingTextPack,
        user: HbsmrUser)
    {
        super(mappingTextPack, user);
        this.init();
    }

    private init = (): void => {
        if (!this.initialised) {
            //strip-loader should take this out for production
            console.log("Initialising main map");                       

            this.layerConfigFactory = new DefaultLayerConfigurationFactory();
            this.vectorLayerGroupFactory = new VectorLayerGroupFactory(); 
            this.wmsLayerGroupFactory = new WmsLayerGroupFactory();
            this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, this.wmsLayerGroupFactory);
            //this.baseLayerFactory = new HighlandBaseMapping_3857();                        
            this.baseLayerFactory = new KentBaseMapping_27700();                        
            
            this.featureLoader = new GeoJsonFeatureLoader();

            this.featureAdd = new FeatureAddSmallGeomsAsPoint(4.5);
            //this.featureAdd = new FeatureAdd();

            this.mapFilter = new MapFilters();
            this.mapFilter.OgcFilter = new OgcMapFilter();
            this.mapFactory = new MapFactory();
            this.logger = new Logger();           
            this.styleFactory = new HbsmrStyleFactory();
            this.resourcefactory = new HbsmrResourcefactory(this.mappingTextPack);

            this.mfOptions = DefaultMapOptions.GetDefaultOptions(this.mapElementId, "MainMap27700");           
            this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
            this.mfOptions.layerGroupCollection = this.layerGroups;
            
            this.mapViewSettingProvider = new MapViewSettingsUrlProvider();
            this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey, this.mapViewSettingProvider);
            
            this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);
            this.herMask = new KentHerBoundary();
            this.mapContextMenu = new MapContextMenu(this.mappingTextPack);
                        
            this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);
            this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);                        

            //let mapScale = (): number => {
            //    const unit = this.map.olMap.getView().getProjection().getUnits();
            //    const resolution = this.map.olMap.getView().getResolution();
            //    const inchesPerMetre = 39.37;
            //    //const dpi = 25.4 / 0.28;
            //    const dpi = 72; //mapserver uses 72
            //    return resolution * METERS_PER_UNIT[unit] * inchesPerMetre * dpi;
            //}

            ////for debug
            //this.map.olMap.on('moveend', function (e: MapEvent) {
            //    let res = e.map.getView().getResolution();
            //    console.log("Map resolution:" + res);
            //    console.log("Map scale:" + mapScale());
            //});

            this.dragPan = new DragPanControlCL(this.map, this.mappingTextPack);
            this.infoPopup = new MapFeatureInfo(this.map, this.resourcefactory.getRecordTypeResource(), this.mappingTextPack);
            let overlays = new CustomMapLayerSwitcherOverlays(this.map, this.mapStore, this.layerGroups, this.mappingTextPack);
            this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack, overlays,
                {
                    showOpenPanelByDefault: !this.printOptions.isPrintMap,
                    rememberActivePanel: true,
                    useBaseLayerSlider: true,
                    baseLayerSliderPosition: 0.6
                });
            this.gridRefFinder = new GridRef(this.map, this.mappingTextPack, this.logger);
            this.geoNames = new GeoNames(this.map, this.mappingTextPack, 10);   

            this.geoNames.locationPinStyle = new Style({
                text: new TextStyle({
                    text: '\uf3c5',
                    font: 'normal 52px "Font Awesome 6 Pro"',
                    textBaseline: 'bottom',
                    fill: new Fill({
                        color: '#ff0000'
                    })
                })
            });

            //this.osOpenNames = new OsOpenNames(this.map, "zcVRhfUNBHp0ZBA0iVMYZh3Q5F2GJGT8",this.mappingTextPack);

            if (this.printOptions.isPrintMap) {                
                this.printOptions.setMap(this.map);
                setTimeout(()=> {
                    this.map.olMap.updateSize();
                }, 0);
            } 

            this.recordList = new MapListRecordsInViewport(this.map, this.mapStore, this.styleFactory, this.layerGroups.vectorLayerGroups, this.mappingTextPack, 14, this.mapListRecordItem);

            this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);            
            //this.geoLocation = new GeoLocation(this.map, this.logger);
            this.extentsNavigation = new ExtentsNavigation(this.map, this.logger, this.mappingTextPack);
            this.mousePosition = new MousePosition(this.map, this.mappingTextPack);
            this.mapViewPermaLink = new MapViewPermaLink(this.map, this.mapViewSettingProvider, this.mappingTextPack, { activePanel: "overlays" });

            if (!('ontouchstart' in window && navigator.maxTouchPoints > 0)) {
                //add tooltip if not touch
                this.mapToolTip = new MapToolTip(this.map, new ToolTipProvider(), new ToolTipOptions(9));
            }           

            this.initialised = true;
        }
    }

    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {       

        let layerGroupConfig: Array<IVectorLayerGroupConfig | IWmsLayerGroupConfig> = [
            this.layerConfigFactory.layerConfig(KentRecordType.Monument, null, { visibleOnFirstLoad: true }),
            //this.layerConfigFactory.layerConfig(KentRecordType.Event),    
            this.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.ListedBuilding),
            this.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.ScheduledMonument),
            this.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.RegisteredParksAndGardens),
            this.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.HistoricParksAndGardens),
            this.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.ConservationArea),
            this.layerConfigFactory.layerConfig(KentRecordType.HistoricLandscapeCharacterisation),
            this.layerConfigFactory.layerConfig(KentRecordType.AreaBoundary)
        ];               

        return [
            {
                ref: "all_layers",
                name: "All layers",
                useAccordion: false,
                expandedOnFirstLoad: true,
                layerGroupConfigs: this.filterMapLayers(layerGroupConfig)
            }
        ];

    }

}




